<template>
  <div class="label-chip">
    <CommonChip v-if="text" size="medium" transparent :color="color">{{ label }}</CommonChip>
    <CommonChip v-else size="medium" transparent color="danger">{{ noText }}</CommonChip>
    <p v-if="text">{{ text }}</p>
  </div>
</template>

<script setup lang="ts">
import CommonChip from '@/components/common/CommonChip.vue'

withDefaults(
  defineProps<{
    label: string
    color?: ApplicationColors
    text?: string
    noText?: string
  }>(),
  {
    noText: 'Aucune donnée'
  }
)
</script>

<style scoped>
.label-chip {
  display: flex;
  gap: 5px;
  align-items: center;
  font-size: 18px;
  color: var(--vc-dark);
}
</style>
